import React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import { Helmet } from 'react-helmet';

import banner from '../images/banner.jpg';
import product1 from '../images/product1.jpg';
import product2 from '../images/product2.jpg';
import product3 from '../images/product3.jpg';
import product4 from '../images/product4.jpg';
import product5 from '../images/product5.jpg';
import product6 from '../images/product6.jpg';
import product7 from '../images/product7.jpg';
import product8 from '../images/product8.jpg';
import product9 from '../images/product9.jpg';
import product10 from '../images/product10.jpg';
import product11 from '../images/product11.jpg';
import product12 from '../images/product12.jpg';
import product13 from '../images/product13.jpg';
import product14 from '../images/product14.jpg';
import product15 from '../images/product15.jpg';
import product16 from '../images/product16.jpg';

const ProductsContainer = styled.div`
  width: 100%;
`;

const BannerSection = styled.section`
  width: 100%;
  background-color: #0099ff;
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  margin-bottom: 0.5rem;
`;

const BannerImage = styled.div`
  width: 80%;
  height: 250px;
  background-image: url(${banner});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const WelcomeSection = styled.section`
  padding: 0 5rem 2rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 0 2rem 1rem;
  }
`;

const WelcomeTitle = styled.h2`
  font-size: 2.4rem;
  color: #0099ff;
  margin: 0 0 1rem;
`;

const WelcomeText = styled.p`
  color: #333;
  line-height: 1.6;
  font-size: 1rem;
  max-width: 100%;
  margin: 0;
`;

const ProductsHeader = styled.h3`
  font-size: 1.2rem;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.5rem;
  margin: 0 5rem 2rem;

  @media (max-width: 768px) {
    margin: 0 2rem 1.5rem;
  }
`;

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.8rem;
  padding: 0 5rem 3rem;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 2rem 2rem;
  }
`;

// ✅ 你原来的卡片（保持不变）
const ProductCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: hidden;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  /* 鼠标悬停时放大、凸出来 */
  &:hover {
    transform: scale(2.5);
    box-shadow: 0 8px 20px rgba(0,0,0,0.2);
    z-index: 10;
  }
`;

// ✅ 新增：左边第一张（向右偏移，不裁切）
const ProductCardLeft = styled(ProductCard)`
  &:hover {
    transform: scale(2.5) translate(20%, 0);
  }
`;

// ✅ 新增：右边最后一张（向左偏移，不裁切）
const ProductCardRight = styled(ProductCard)`
  &:hover {
    transform: scale(2.5) translate(-20%, 0);
  }
`;

const ProductImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  object-position: center;
  display: block;
`;

const ProductCaption = styled.p`
  font-size: 16px;
  font-weight: bold;
  color: #666;
  margin: 0;
  text-align: center;
  padding: 0.5rem;
`;

const ProductsPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>Products - Wisdom Home Appliances</title>
        <meta name="description" content="Wisdom product information and company exhibition history" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <ProductsContainer>
        <BannerSection>
          <BannerImage />
        </BannerSection>

        <WelcomeSection>
          <WelcomeTitle>WELCOME</WelcomeTitle>
          <WelcomeText>
            To OEM and ODM consumer electronics, Home appliances, Small Home appliances, since 2006, we supply high quality and good service to our clients. Since 2019, we have started to sell our Wisdom brands products in Asia market by lazada. Now we have more than 500 SKU available for OEM and wholesale.
          </WelcomeText>
        </WelcomeSection>

        <ProductsHeader>Products</ProductsHeader>

        <ProductGrid>
          {/* 第 1 行 */}
          <ProductCardLeft>
            <ProductImage src={product1} alt="Product 1" />
            <ProductCaption>Product 1</ProductCaption>
          </ProductCardLeft>
          <ProductCard>
            <ProductImage src={product2} alt="Product 2" />
            <ProductCaption>Product 2</ProductCaption>
          </ProductCard>
          <ProductCard>
            <ProductImage src={product3} alt="Product 3" />
            <ProductCaption>Product 3</ProductCaption>
          </ProductCard>
          <ProductCardRight>
            <ProductImage src={product4} alt="Product 4" />
            <ProductCaption>Product 4</ProductCaption>
          </ProductCardRight>

          {/* 第 2 行 */}
          <ProductCardLeft>
            <ProductImage src={product5} alt="Product 5" />
            <ProductCaption>Product 5</ProductCaption>
          </ProductCardLeft>
          <ProductCard>
            <ProductImage src={product6} alt="Product 6" />
            <ProductCaption>Product 6</ProductCaption>
          </ProductCard>
          <ProductCard>
            <ProductImage src={product7} alt="Product 7" />
            <ProductCaption>Product 7</ProductCaption>
          </ProductCard>
          <ProductCardRight>
            <ProductImage src={product8} alt="Product 8" />
            <ProductCaption>Product 8</ProductCaption>
          </ProductCardRight>

          {/* 第 3 行 */}
          <ProductCardLeft>
            <ProductImage src={product9} alt="Product 9" />
            <ProductCaption>Product 9</ProductCaption>
          </ProductCardLeft>
          <ProductCard>
            <ProductImage src={product10} alt="Product 10" />
            <ProductCaption>Product 10</ProductCaption>
          </ProductCard>
          <ProductCard>
            <ProductImage src={product11} alt="Product 11" />
            <ProductCaption>Product 11</ProductCaption>
          </ProductCard>
          <ProductCardRight>
            <ProductImage src={product12} alt="Product 12" />
            <ProductCaption>Product 12</ProductCaption>
          </ProductCardRight>

          {/* 第 4 行 */}
          <ProductCardLeft>
            <ProductImage src={product13} alt="Product 13" />
            <ProductCaption>Product 13</ProductCaption>
          </ProductCardLeft>
          <ProductCard>
            <ProductImage src={product14} alt="Product 14" />
            <ProductCaption>Product 14</ProductCaption>
          </ProductCard>
          <ProductCard>
            <ProductImage src={product15} alt="Product 15" />
            <ProductCaption>Product 15</ProductCaption>
          </ProductCard>
          <ProductCardRight>
            <ProductImage src={product16} alt="Product 16" />
            <ProductCaption>Product 16</ProductCaption>
          </ProductCardRight>
        </ProductGrid>
      </ProductsContainer>
    </Layout>
  );
};

export default ProductsPage;